import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles/index';

const styles = () => ({

});

function ContinueButton(props) {
    const {
        onClick,
        ...other
    } = props;
    return (
        <Button
            {...other}
            onClick={onClick}
            variant="raised"
            color="primary"
        >
            { props.children &&
                props.children
            }
            {!props.children &&
                'Continue'
            }
        </Button>
    );
}

ContinueButton.propTypes = {
    classes: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.string,
};

ContinueButton.defaultProps = {
    children: '',
};

export default withStyles(styles)(ContinueButton);



// WEBPACK FOOTER //
// ./src/app/common/components/Buttons/ContinueButton.js